import * as React from "react";
import { ServiceStoreContainer } from "../../../../containers/modules/ServiceStore/containers/ServiceStoreContainer.js";
const ServiceStore = React.memo((props) => /* @__PURE__ */ React.createElement(ServiceStoreContainer, { ...props }));
export {
  ServiceStore
};
//# sourceMappingURL=ServiceStore.js.map
